var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00579F",
    d: "M13.79 10.41L11.181 10.41 12.813.386 15.422.386zM23.133.429C22.626.225 21.82 0 20.827 0c-2.538 0-4.326 1.372-4.337 3.334-.021 1.447 1.28 2.251 2.253 2.734.994.493 1.332.815 1.332 1.254-.01.675-.803.986-1.543.986-1.027 0-1.576-.16-2.412-.536l-.339-.16-.36 2.261c.604.279 1.714.526 2.868.537 2.697 0 4.453-1.351 4.473-3.442.01-1.147-.676-2.026-2.157-2.744-.9-.461-1.45-.772-1.45-1.244.01-.429.466-.868 1.48-.868.836-.021 1.45.182 1.915.386l.233.107.35-2.176zM26.737 6.859l1.03-2.805c-.012.021.211-.587.338-.96l.18.864s.489 2.4.595 2.9h-2.143zM29.92.386h-1.995c-.615 0-1.082.18-1.348.831l-3.83 9.193h2.706l.54-1.504h3.312c.074.352.307 1.504.307 1.504H32L29.92.386zM9.177.386l-2.57 6.842-.28-1.388c-.475-1.6-1.965-3.34-3.628-4.206l2.354 8.776h2.774L11.952.386H9.177z",
    transform: "translate(-32 -240) translate(16 152) translate(16 86) translate(0 2) translate(0 11)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAA61A",
    d: "M4.13.386H.042L0 .586c3.189.824 5.301 2.81 6.169 5.197L5.28 1.22C5.134.586 4.684.406 4.13.386z",
    transform: "translate(-32 -240) translate(16 152) translate(16 86) translate(0 2) translate(0 11)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.c3c278d3.svg";
export { ForwardRef as ReactComponent };